import React from 'react';

const Wrapper = ({ children, className, noMargin, noPadding, ...rest }) => {
    return (
        <div className={`rounded-3 ${!noMargin && 'mb-4'} theme-bg-color ${!noPadding && 'p-3'} ${className || ''}`} {...rest}>
            {children || ''}
        </div>
    );
};

export default Wrapper;
